import { useFormik } from "formik";
import React, { useCallback } from "react";
import { openingAmountSchema } from "../../Schema/BadlaSchema";
import { Button, Error, Input, Label } from "../../Components";
import { postAxios } from "../../Services/commonService";

const Opening = ({ rowData, handleShowHide }) => {
  console.log("🚀 ~ Opening ~ rowData:", rowData);
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
  } = useFormik({
    initialValues: {
      openingAmount: 0,
    },
    enableReinitialize: true,
    validationSchema: openingAmountSchema,
    onSubmit: (values) => {
      handleFormSubmit({ values });
    },
  });

  const handleFormSubmit = useCallback(async ({ values }) => {
    const res = await postAxios({
      url: "/badlaOrder/updateOpeningAmount",
      payload: {
        badlaId: rowData?.badlRefId,
        openingAmount: values?.openingAmount,
        userId: rowData?.userId,
      },
    });

    handleShowHide();
  }, []);

  return (
    <form className="form-order" onSubmit={handleSubmit}>
      <div className="row  m-0 p-0 align-items-end">
        <div className="col-lg-12 col-sm-12 col-6 m-0 p-1">
          <div className="form-group ">
            <Label className="lead_text">Opening Amount</Label>
            <Input
              type="number"
              placeholder="Enter Amount"
              className="form-control"
              name="openingAmount"
              onChange={handleChange}
              onblur={handleBlur}
              value={values.openingAmount}
              id="openingAmount"
              autoFocus={true}
            />
            {errors?.openingAmount && touched?.openingAmount && (
              <Error>{errors?.openingAmount}</Error>
            )}
          </div>
        </div>
      </div>
      <Button type="submit" id="form-submit-btn" hidden={true}></Button>
    </form>
  );
};

export default Opening;
